<div class="relative">
  <div class="container w-[260px] min-w-full">
    <div
      class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2"
    >
      <div class="flex items-center gap-3 w-full">
        <div>
          <tui-svg src="tuiIconCreditCardLarge" style="color: black"></tui-svg>
        </div>
        <div>
          <h3 class="flex items-center text-black text-[1.5rem] font-bold">
            Payments
          </h3>
        </div>
      </div>
      <div class="flex gap-2 mt-3 sm:mt-0">
        <div class="">
          <button tuiButton appearance="" (click)="toggle()" class="">
            <div
              class="flex justify-center items-center btn-outline w-[80px] sm:w-[160px]"
            >
              <tui-svg
                src="tuiIconSlidersLarge"
                class="sm:pt-3 rotate-90 flex items-center"
                style="color: #bb0021"
              ></tui-svg>
              <p class="hidden sm:block">Advanced Search</p>
            </div>
          </button>
        </div>
        <div class="">
          <button tuiButton appearance="" class="" (click)="navigateToAdd()">
            <div
              class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline"
            >
              <p class="flex justify-center items-center text-[13px] h-[24px]">
                Add Payment
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>

    <tui-loader [overlay]="true" [showLoader]="isLoading">
      <div class="flex justify-between border-b border-[#bb0021] py-2">
        <!-- Payment Summary Section -->
        <div class="w-full py-3 flex flex-col sm:flex-row gap-8 items-center">
          <div class="flex flex-col items-start">
            <span class="text-[1rem] font-semibold text-black">Total Cash</span>
            <span class="text-[#f84061] text-[1.25rem] font-bold">
              LKR {{ allFilteredTotals.cash | number : "1.2-2" }}
            </span>
          </div>
          <div class="flex flex-col items-start">
            <span class="text-[1rem] font-semibold text-black"
              >Total Online</span
            >
            <span class="text-[#f84061] text-[1.25rem] font-bold">
              LKR {{ allFilteredTotals.online | number : "1.2-2" }}
            </span>
          </div>
          <div class="flex flex-col items-start">
            <span class="text-[1rem] font-semibold text-black"
              >Total Payments (Combined)</span
            >
            <span class="text-[#bb0021] text-[1.25rem] font-bold">
              LKR {{ allFilteredTotals.combined | number : "1.2-2" }}
            </span>
          </div>
        </div>
        <div class="w-full flex justify-end items-center gap-2">
          <button
            tuiButton
            appearance="secondary"
            class="btn-outline"
            [disabled]="sendingReport"
            (click)="sendDailyReportEmail()"
          >
            <div class="p-4 flex justify-center items-center">
              <tui-svg src="tuiIconMailLarge" class="mr-2"></tui-svg>
              {{ sendingReport ? 'Sending…' : 'Send Daily Report Email' }}
            </div>
          </button>
          <button
            tuiButton
            appearance="primary"
            class="btn-outline"
            (click)="downloadTableExcel()"
          >
            <div class="p-4 text-white flex justify-center items-center">
              <tui-svg src="tuiIconDownloadLarge" class="mr-2"></tui-svg>
              Download Excel
            </div>
          </button>
        </div>
      </div>
    </tui-loader>

    <div class="mt-2 sm:mt-0 mb-3">
      <div class="flex flex-col lg:flex-row justify-between" *ngIf="showSearch">
        <div
          class="flex  bg-cover sm:items-center gap-1 flex-col sm:flex-row"
        >
          <div class="w-full sm:w-40 lg:w-60">
            <tui-input
              tuiTextfieldIconLeft="tuiIconSearchLarge"
              [tuiTextfieldCleaner]="true"
              tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true"
              [style.text-align]="'left'"
              class=""
              [(ngModel)]="searchText"
              (tuiValueChanges)="cancelSearch($event)"
            >
              Search
              <input autocomplete="fname" tuiTextfield type="text" />
            </tui-input>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-40 lg:w-60 py-3 flex items-center gap-1">
            <tui-select
              [(ngModel)]="dateTypeSelect"
              tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true"
              [style.text-align]="'left'"
              class="flex-1"
            >
              Date filter by
              <input tuiTextfield type="text" />
              <tui-data-list-wrapper *tuiDataList [items]="dateType">
              </tui-data-list-wrapper>
            </tui-select>
            <span
              class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#00000014] cursor-help shrink-0"
              [tuiHint]="dateFilterTypeTooltip"
              tuiHintDirection="bottom"
              [tuiHintShowDelay]="300"
              tuiHintAppearance="onDark"
            >
              <tui-svg src="tuiIconHelpCircle" class="text-[#6A6A6A]"></tui-svg>
            </span>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-60 py-3">
            <tui-combo-box
              [(ngModel)]="memberFilter"
              [stringify]="stringify"
              tuiTextfieldSize="m"
            >
              Member
              <input placeholder="Search by member" tuiTextfield />
              <tui-data-list-wrapper
                *tuiDataList
                [itemContent]="stringify | tuiStringifyContent"
                [items]="tableMembers | tuiFilterByInputWith : stringify"
              ></tui-data-list-wrapper>
            </tui-combo-box>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-60 py-3 flex items-center gap-1">
            <tui-select
              [(ngModel)]="paymentMethodFilter"
              tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true"
              [style.text-align]="'left'"
              class="flex-1"
            >
              Payment Type
              <input tuiTextfield type="text" placeholder="All" />
              <tui-data-list-wrapper
                *tuiDataList
                [items]="paymentMethodOptions"
              >
              </tui-data-list-wrapper>
            </tui-select>
            <span
              class="inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#00000014] cursor-help shrink-0"
              [tuiHint]="'Filter by payment method: Online or Cash.'"
              tuiHintDirection="bottom"
              [tuiHintShowDelay]="300"
              tuiHintAppearance="onDark"
            >
              <tui-svg src="tuiIconHelpCircle" class="text-[#6A6A6A]"></tui-svg>
            </span>
          </div>
          <div
            class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"
            *ngIf="dateTypeSelect"
          ></div>
          <div class="w-full sm:w-60 py-3" *ngIf="dateTypeSelect">
            <tui-input-date-range
              class="b-form"
              tuiTextfieldSize="m"
              [(ngModel)]="dateFilter"
            >
              Choose dates
            </tui-input-date-range>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-[100px] my-3">
            <button
              tuiButton
              tuiTextfieldSize="s"
              type="button"
              class="w-full"
              (click)="search()"
            >
              <tui-svg
                src="tuiIconSearchLarge"
                class="pr-2 text-white"
              ></tui-svg>
              <span class="text-white">Search</span>
            </button>
          </div>
        </div>
        <!--            <div class="text-[#FFFFFFB8] flex gap-1 items-center justify-end">-->
        <!--                <label>-->
        <!--                    Active-->
        <!--                    <tui-toggle-->
        <!--                        size="l"-->
        <!--                        class=""-->
        <!--                    ></tui-toggle>-->
        <!--                </label>-->
        <!--            </div>-->
      </div>
      <div
        class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2 w-full"
        *ngIf="statusMsg || reportMessage"
      >
        <div class="flex items-center">
          <img src="/assets/img/resulticon.png" alt="" />
          <p class="text-black pl-2">
            {{ reportMessage || getFilterSummary() }}
          </p>
        </div>
        <div>
          <button
            class="text-[#bb0021] hover:scale-110 transition-all duration-100"
            (click)="resetStatus(); reportMessage = null"
          >
            Reset
          </button>
        </div>
      </div>
    </div>

    <!-- Month navigation: default view is current month by payment date -->
    <div
      class="flex items-center justify-between gap-4 py-3 border-b border-[#bb0021]"
      *ngIf="!showSearch"
    >
      <span class="text-[1rem] font-semibold text-black">Payments by Month - Based on Payment Date</span>
      <div class="flex items-center gap-2">
        <button
          tuiButton
          appearance="flat"
          (click)="goToPreviousMonth()"
          class="btn-outline"
        >
          <div class="flex justify-center items-center mx-3">
            <tui-svg src="tuiIconChevronLeft" class="mr-1 "></tui-svg>
            Previous month
          </div>
        </button>
        <span class="min-w-[140px] text-center text-[1rem] font-bold text-[#bb0021]">
          {{ selectedMonthLabel }}
        </span>
        <button
          tuiButton
          appearance="flat"
          (click)="goToNextMonth()"
          class="btn-outline"
          [disabled]="isNextMonthDisabled"
        >
          <div class="flex justify-center items-center mx-3">
            Next month
            <tui-svg src="tuiIconChevronRight" class="ml-1"></tui-svg>
          </div>
        </button>
      </div>
    </div>

    <tui-loader [overlay]="true" [showLoader]="isLoading">
      <div
        *ngIf="paymentData.length > 0"
        class="overflow-x-scroll"
        style="white-space: nowrap"
      >
        <table class="tui-table w-full">
          <thead tuiThead class="">
            <tr class="tui-table__tr">
              <th class="tui-table__th">Payment ID</th>
              <th class="tui-table__th">Member Name</th>
              <th class="tui-table__th">Member ID</th>
              <th class="tui-table__th">
                <div class="flex">
                  <span>Validity Period From</span>
                  <tui-svg
                    class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronUp"
                    (click)="toggleSortValidFromDate()"
                    *ngIf="validFromSort === -1"
                  ></tui-svg>

                  <tui-svg
                    class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronDown"
                    (click)="toggleSortValidFromDate()"
                    *ngIf="validFromSort === 1"
                  ></tui-svg>
                </div>
              </th>
              <th class="tui-table__th">
                <div class="flex">
                  <span>Validity Period To</span>
                  <tui-svg
                    class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronUp"
                    (click)="toggleSortValidToDate()"
                    *ngIf="validToSort === -1"
                  ></tui-svg>

                  <tui-svg
                    class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronDown"
                    (click)="toggleSortValidToDate()"
                    *ngIf="validToSort === 1"
                  ></tui-svg>
                </div>
              </th>
              <th class="tui-table__th">
                <div class="flex">
                  <span>Payment Date</span>
                  <tui-svg
                    class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronUp"
                    (click)="toggleSortPaymentDate()"
                    *ngIf="paymentDateSort === -1"
                  ></tui-svg>

                  <tui-svg
                    class="nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronDown"
                    (click)="toggleSortPaymentDate()"
                    *ngIf="paymentDateSort === 1"
                  ></tui-svg>
                </div>
              </th>
              <th class="tui-table__th">Amount (LKR)</th>
              <th class="tui-table__th">Payment Type</th>
              <th class="tui-table__th">Notes</th>
              <th class="tui-table__th">Status</th>
              <th class="tui-table__th">Payment Presets</th>
              <th class="tui-table__th">Staff Name</th>
              <!--            <th class="tui-table__th" *ngIf="user.role !== 'USER'">Actions</th>-->
            </tr>
          </thead>
          <tbody class="">
            <tr
              class="tui-table__tr"
              *ngFor="let data of paymentData; let i = index"
            >
              <td class="tui-table__td">
                {{ data.paymentId ? data.paymentId : "-" }}
              </td>
              <td class="tui-table__td">
                {{
                  data.member?.firstname
                    ? data.member?.firstname + " " + data.member?.lastname
                    : "-"
                }}
              </td>
              <td
                class="tui-table__td no-underline hover:underline cursor-pointer"
                style="color: #bb0021"
                (click)="navToSingleMember(data.member?._id)"
              >
                {{ data.member?.membershipId ? data.member.membershipId : "-" }}
              </td>
              <td class="tui-table__td">
                {{ data.validFrom ? formatDate(data.validFrom) : "-" }}
              </td>
              <td class="tui-table__td">
                {{ data.validTo ? formatDate(data.validTo) : "-" }}
              </td>
              <td class="tui-table__td">
                {{ data.date ? formatDate(data.date) : "-" }}
              </td>
              <td class="tui-table__td">
                {{ data.amount ? (data.amount | number : "1.2-2") : "-" }}
              </td>
              <td class="tui-table__td">{{ showPaymentMethod(data) }}</td>
              <td class="tui-table__td">{{ data.notes ? data.notes : "-" }}</td>
              <td class="tui-table__td">
                <app-status-badge [status]="data.status"></app-status-badge>
              </td>

              <td class="tui-table__td">
                {{ data.paymentPreset ? data.paymentPreset : "-" }}
              </td>
              <td class="tui-table__td">
                {{
                  data.handledBy?.firstname
                    ? data.handledBy?.firstname + " " + data.handledBy?.lastname
                    : "Self payment"
                }}
              </td>
              <!--            <td class="tui-table__td " *ngIf="user.role !== 'USER'">-->
              <!--              <div class=" flex items-center justify-between">-->
              <!--                <a class="text-[#B3D334] hover:scale-110 transition-all duration-100" style="cursor: pointer" (click)="navigateToUpdate(data)">Edit</a>-->
              <!--              </div>-->
              <!--            </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="paymentData.length === 0 && !isLoading" class="mt-3">
        <p class="text-[#D8D8D8] text-center">No Data</p>
      </div>
    </tui-loader>
    <div class="text-white py-10 flex justify-end w-full max-w-full">
      <tui-pagination
        [index]="pageSize.pageIndex - 1"
        [length]="pageSize.length"
        (indexChange)="goToPage($event)"
        class="text-white"
      >
      </tui-pagination>
    </div>
  </div>
</div>
